import React from 'react';
import { Switch, NavLink } from "react-router-dom";
import { AuthConsumer } from "../../context/AuthContext";

import ProtectedRoute from '../ProtectedRoute.js';
import WorkshopCategories from './WorkshopCategories';
import WorkshopCategory from './WorkshopCategory';
import WorkshopOrganizations from './WorkshopOrganizations';
import WorkshopOrganization from './WorkshopOrganization';
//import Instructors from './Instructors';
import Instructor from './Instructor';
import LocationTemplates from './LocationTemplates';
import LocationTemplate from './LocationTemplate';
import ContactTemplates from './ContactTemplates';
import ContactTemplate from './ContactTemplate';
import GeoGroups from './GeoGroups';
import GeoGroup from './GeoGroup';

import WorkshopsAdmin from './WorkshopsAdmin';

import withStyles from '@mui/styles/withStyles';
import AdminRolesUpdate from './AdminRolesUpdate';
import AdminUsersSearch from './AdminUsersSearch';

import UserAdmin from './UserAdmin'
import AdminInstrucManage from './AdminInstrucManage';
import AdminInstrucAdd from './AdminInstrucAdd';
import AdminRoles from './AdminRoles';
import AdminRolesManage from './AdminRolesManage';
import AdminManageCourses from './AdminManageCourses';
import AdminCoursesCreateEdit from './AdminCoursesCreateEdit';
import AdminViewTransactions from './AdminViewTransactions';
import AdminViewTransacViewEdit from './AdminViewTransacViewEdit';
import AdminUserPurchase from './AdminUserPurchase';
import AdminEmployerPurchase from './AdminEmployerPurchase';
import UserLog from './UserLog';
import UserCredit from './AdminUserCredit';
import AdminEmployers from './AdminEmployers';
import AdminEmployerCredit from './AdminEmployerCredit';
import AdminEmployerTraining from './AdminEmployerTraining';

import ViewQuizQuestions from './ViewQuizQuestions';
import TrainingHist from '../dashboard/TrainingHist';
import TrainingHistDetails from '../dashboard/TrainingHistDetails';
import EmployerAdmin from '../dashboard/EmployerAdmin';
import EmployerTraining from '../dashboard/EmployerTraining';

import AdminTrainingReport from './AdminTrainingReport';

import AdminManageTrainingCode from './AdminManageTrainingCode';

import AdminTrainingProvider from './AdminTrainingProvider';
import TrainingProvManage from '../dashboard/TrainingProvManage';
import TrainingProvider from '../dashboard/TrainingProvider';

import AdminBlankCertificate from './AdminBlankCertificate';


const styles = theme => ({
    subNavBar: {
        backgroundColor: "#00529b",
    }
});

const Administration = props => {
    const { path } = props.match;
    const { classes } = props;





    return (
        <div>
            <div id="sub-navbar" className={classes.subNavBar}>
                <AuthConsumer>
                    {({ authenticated, roles }) =>
                        authenticated && roles.isUserAdmin ? (
                            <NavLink to={`${path}`} activeClassName="active-tab" className="sub-navlink" exact>Users</NavLink>
                        ) : null
                    }
                </AuthConsumer>

                <AuthConsumer>
                    {({ authenticated, roles }) =>
                        authenticated && roles.isTrainingCouponAdmin ? (
                            <NavLink to={`${path}/employers`} activeClassName="active-tab" className="sub-navlink" >Employers</NavLink>
                        ) : null
                    }
                </AuthConsumer>
                <AuthConsumer>
                    {({ authenticated, roles }) =>
                        authenticated && roles.isTrainingCouponAdmin ? (
                            <NavLink to={`${path}/viewTransactions`} activeClassName="active-tab" className="sub-navlink" > Transactions </NavLink>
                        ) : null
                    }
                </AuthConsumer>

                <AuthConsumer>
                    {({ authenticated, roles }) =>
                        authenticated && roles.isTrainingCouponAdmin ? (
                            <NavLink to={`${path}/trainingReport`} activeClassName="active-tab" className="sub-navlink" > Training Report </NavLink>
                        ) : null
                    }
                </AuthConsumer>

                <AuthConsumer>
                    {({ authenticated, roles }) =>
                        authenticated && roles.isClassroomTrainingManager ? (
                            <NavLink to={`${path}/admin/classes`} activeClassName="active-tab" className="sub-navlink" exact>Classes</NavLink>
                        ) : null
                    }
                </AuthConsumer>
              
                <AuthConsumer>
                    {({ authenticated, roles }) =>
                        authenticated && roles.isTrainingCouponAdmin ? (
                            <NavLink to={`${path}/manageTrainingCode`} activeClassName="active-tab" className="sub-navlink" > Training Code </NavLink>
                        ) : null
                    }
                </AuthConsumer>

                <AuthConsumer>
                    {({ authenticated, roles }) =>
                        authenticated && roles.isTrainingCouponAdmin ? (
                            <NavLink to={`${path}/trainingProviders`} activeClassName="active-tab" className="sub-navlink" > Training Providers </NavLink>
                        ) : null
                    }
                </AuthConsumer>

                <NavLink to={`${path}/LocationTemplates`} activeClassName="active-tab" className="sub-navlink" exact>Locations</NavLink>
                <NavLink to={`${path}/ContactTemplates`} activeClassName="active-tab" className="sub-navlink" exact>Contacts</NavLink>
                <NavLink to={`${path}/instructors`} activeClassName="active-tab" className="sub-navlink">Instructors</NavLink>
                <NavLink to={`${path}/category`} activeClassName="active-tab" className="sub-navlink" exact>Categories</NavLink>
                <NavLink to={`${path}/workshopOrganizations`} activeClassName="active-tab" className="sub-navlink" exact>Organizations</NavLink>
                <NavLink to={`${path}/GeoGroups`} activeClassName="active-tab" className="sub-navlink" exact>Regions</NavLink>  

                <AuthConsumer>
                    {({ authenticated, roles }) =>
                        authenticated && roles.isRoleAdmin ? (
                            <NavLink to={`${path}/roles`} activeClassName="active-tab" className="sub-navlink" >Roles</NavLink>
                        ) : null
                    }
                </AuthConsumer>
               
                <AuthConsumer>
                    {({ authenticated, roles }) =>
                        authenticated && roles.isOnlineTrainingEditor ? (
                            <NavLink to={`${path}/manageCourses`} activeClassName="active-tab" className="sub-navlink" >Courses Admin</NavLink>
                        ) : null
                    }
                </AuthConsumer>

                <AuthConsumer>
                    {({ authenticated, roles }) =>
                        authenticated && roles.isRoleAdmin ? (
                            <NavLink to={`${path}/generateCertificate`} activeClassName="active-tab" className="sub-navlink" >Certificate</NavLink>
                        ) : null
                    }
                </AuthConsumer>
 
            </div>

            <div>
                <Switch>
                    {/* <ProtectedRoute path={`${path}/instructors`} exact component={Instructors} /> */}
                    <ProtectedRoute path={`${path}/workshopCategory/:id`} component={WorkshopCategory} />
                    <ProtectedRoute path={`${path}/workshopCategory`} component={WorkshopCategory} />
                    <ProtectedRoute path={`${path}/instructors`} exact component={AdminInstrucManage} />
                    <ProtectedRoute path={`${path}/instructors/add`} exact component={AdminInstrucAdd} />
                    <ProtectedRoute path={`${path}/instructor/:username`} component={Instructor} />
                    <ProtectedRoute path={`${path}/instructor`} component={Instructor} />
                    <ProtectedRoute path={`${path}/category`} exact component={WorkshopCategories} />
                    <ProtectedRoute path={`${path}/WorkshopOrganizations`} component={WorkshopOrganizations} />
                    <ProtectedRoute path={`${path}/workshopOrganization/:id`} component={WorkshopOrganization} />
                    <ProtectedRoute path={`${path}/workshopOrganization`} component={WorkshopOrganization} />
                    <ProtectedRoute path={`${path}/LocationTemplates`} component={LocationTemplates} />
                    <ProtectedRoute path={`${path}/locationTemplate/:id`} component={LocationTemplate} />
                    <ProtectedRoute path={`${path}/locationTemplate`} component={LocationTemplate} />
                    <ProtectedRoute path={`${path}/ContactTemplates`} component={ContactTemplates} />
                    <ProtectedRoute path={`${path}/contactTemplate/:id`} component={ContactTemplate} />
                    <ProtectedRoute path={`${path}/contactTemplate`} component={ContactTemplate} />
                    <ProtectedRoute path={`${path}/GeoGroups`} component={GeoGroups} />
                    <ProtectedRoute path={`${path}/geoGroup/:id`} component={GeoGroup} />
                    <ProtectedRoute path={`${path}/geoGroup`} component={GeoGroup} />

                    <ProtectedRoute path={`${path}/trainingReport`} component={AdminTrainingReport} />

                    <ProtectedRoute path={`${path}/admin/classes`} component={WorkshopsAdmin} />
                    
                    <ProtectedRoute path={`${path}/users/roles/:username`} component={AdminRolesUpdate} />
                    
                    <ProtectedRoute path={`${path}/users/:username/trainingHistory/details`} component={TrainingHistDetails} from="admin"/>
                    <ProtectedRoute path={`${path}/users/:username/trainingHistory`} component={TrainingHist} from="admin"/>
                    <ProtectedRoute path={`${path}/users/:id`} component={UserAdmin}/>

                    <ProtectedRoute path={`${path}/quiz/questions/:id`} component={ViewQuizQuestions} />

                    <ProtectedRoute path={`${path}/roles/:role`} component={AdminRolesManage} />
                    <ProtectedRoute path={`${path}/roles`} component={AdminRoles} />

                    <ProtectedRoute path={`${path}/manageCourses/create`} component={AdminCoursesCreateEdit} create />
                    <ProtectedRoute path={`${path}/manageCourses/edit/:id`} component={AdminCoursesCreateEdit} edit />
                    <ProtectedRoute path={`${path}/manageCourses`} component={AdminManageCourses} />

                    <ProtectedRoute path={`${path}/viewTransactions/:id`} component={AdminViewTransacViewEdit} />
                    <ProtectedRoute path={`${path}/viewTransactions`} component={AdminViewTransactions} />

                    <ProtectedRoute path={`${path}/userPurchase/user/:username`} component={AdminUserPurchase}/>
                    <ProtectedRoute path={`${path}/userPurchase/employer/:employerID`} component={AdminEmployerPurchase}/>
                    <ProtectedRoute path={`${path}/userLog/:username`} component={UserLog}/>
                    <ProtectedRoute path={`${path}/userCredit/:username`} component={UserCredit}/>

                    <ProtectedRoute path={`${path}/employers`} component={AdminEmployers}/>
                    <ProtectedRoute path={`${path}/employer/admin/:id`} component={EmployerAdmin} />
                    <ProtectedRoute path={`${path}/employer/training/:id`} component={EmployerTraining} admin/>
                    <ProtectedRoute path={`${path}/employer/correctTraining/:id`} component={AdminEmployerTraining} />

                    <ProtectedRoute path={`${path}/creditHistory/employer/:id`} component={AdminEmployerCredit} />

                    <ProtectedRoute path={`${path}/trainingProviders/members/:id`} component={TrainingProvider}/>
                    <ProtectedRoute path={`${path}/trainingProviders/edit/:id`} component={TrainingProvider} admin/>
                    <ProtectedRoute path={`${path}/trainingProviders/manageClasses/:id`} component={TrainingProvManage} admin/>

                    <ProtectedRoute path={`${path}/trainingProviders`} component={AdminTrainingProvider}/>

                    

                    <ProtectedRoute path={`${path}/manageTrainingCode`} component={AdminManageTrainingCode} />

                    <ProtectedRoute path={`${path}/generateCertificate`} component={AdminBlankCertificate} />
                    <ProtectedRoute path={`${path}`} component={AdminUsersSearch} />

                </Switch>
            </div>
        </div>
    );

}

export default withStyles(styles, { withTheme: true })(Administration);
